export default "/images/d8c3ebff9b6fba495d9ba18a6314ad0b.avif";